(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eyre-product-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eyre-product-comparison')) {
    customElements.define('eyre-product-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const range = this.querySelector('input');
        if (!range) return;
        range.value = Number.isFinite(parseFloat(this.style.getPropertyValue('--eyre-split'))) ? parseFloat(this.style.getPropertyValue('--eyre-split')) : 50;
        this.dataset.ready = 'true';
        range.addEventListener('input', () => this.style.setProperty('--eyre-split', `${range.value}%`));
        range.addEventListener('keydown', event => event.stopPropagation());
        this.querySelector('.eyre-comparison__expand')?.addEventListener('click', event => {
          event.stopPropagation();
          const button = event.currentTarget;
          const dialog = document.createElement('dialog');
          dialog.className = 'eyre-comparison__dialog';
          dialog.setAttribute('aria-label', button.dataset.dialogLabel);
          const frame = document.createElement('div');
          frame.className = 'media';
          const comparison = this.cloneNode(true);
          comparison.removeAttribute('data-ready');
          comparison.querySelector('.eyre-comparison__expand').remove();
          const input = comparison.querySelector('input');
          input.id += '-expanded';
          input.value = range.value;
          comparison.querySelector('label').htmlFor = input.id;
          const close = document.createElement('button');
          close.type = 'button';
          close.className = 'eyre-comparison__close';
          close.textContent = button.dataset.closeLabel;
          close.addEventListener('click', () => dialog.close());
          frame.append(comparison);
          dialog.append(frame, close);
          dialog.addEventListener('close', () => { dialog.remove(); button.focus(); }, { once: true });
          this.append(dialog);
          dialog.showModal();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
